export enum UserLoginEnum {
  email= 'email',
  facebook = 'facebook',
  google='google'
}
